import styled from 'styled-components'

export const Container = styled('div')`
  margin-bottom: 12px;
`

export const Divider = styled.div`
  margin: 30px 0 15px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey24};
`

export const CardContainer = styled('div')`
  margin-top: 12px;
`

export const Title = styled('p')`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.secondary.normal};
  font-weight: 600;
  line-height: 24px;
  margin: 15px 0;
`
